// ------------------
// Constants
// ------------------

const origin = 'https://hhpls7ie4f.execute-api.ap-northeast-1.amazonaws.com/prod/streetview-proxy';

const defaults = {
    key: GM_KEY,
    fov: 120,
    source: 'outdoor'
};



// ------------------
// Exports
// ------------------

export default function (building, el) {
    const style = window.getComputedStyle(el);
    const width = parseInt(style.getPropertyValue('width'));
    const height = parseFloat(style.getPropertyValue('height'));
    const size = `${width}x${height}`;
    const location = building.address;
    const pitch = building.floorsCount > 0 ? Math.log2(building.floorsCount) * 10 : 45;
    const params = new URLSearchParams({...defaults, size, location, pitch});
    return `${origin}?${params.toString()}`
}